export default __webpack_public_path__ + "static/media/mugLeftiesT.df1f2ef3.jpg";